<span fxLayout="row">
  <img
    #helpIconRef
    alt=""
    width="{{showDarkIcon ? 15 : 12}}"
    height="{{showDarkIcon ? 15 : 12}}"
    src="{{showDarkIcon ? 'assets/icons/info_country_risk_dark.svg' : 'assets/icons/info_country_risk.svg' }}"
    [matMenuTriggerFor]="toolTip"
    style="display: flex; cursor: pointer; align-self: center"
    class="helpIcon"
  />

  <mat-menu #toolTip="matMenu">
    <div>
      <div
        fxLayout="column"
        style="padding: 10px; font-size: 12px; color: #9b9b9b"
      >
        <span style="font-weight: bold">Travel Risk </span>
        <span>{{ getData("travelRisk") }}</span>
      </div>
      <div style="border-bottom: 1px solid #979797; opacity: 0.22"></div>
      <div
        fxLayout="column"
        style="padding: 10px; font-size: 12px; color: #9b9b9b"
      >
        <span style="font-weight: bold">Authorisation to Travel</span>
        <span>{{ getData("authorisationToTravel") }}</span>
      </div>
    </div>
  </mat-menu>
</span>
